import React from 'react';

const ImagenIniciarSesion = () => {
  return(
    <div className='imagen-registro'>
      <h1>FOODIED</h1>
      <img src="/Imagenes/Hero/Arroz.jpg" alt="Arroz" />
    </div>
  )
}

export { ImagenIniciarSesion }